<div class="p-2 fill-column">
  <div class="flex flex-wrap justify-content-between align-items-center mb-2">
    <div class="font-semibold text-2xl mb-3" data-clarity-unmask="true">Kursanci</div>
    <div class="flex gap-3">
      <div class="bg-white " [ngStyle]="{'border-radius': '5px'}" >
        <!-- <p-button icon="pi pi-send" [outlined]="true" label="Zaproś" (onClick)="showInviteModal()"></p-button> -->
      </div>
      <p-button *ngIf="canAdministerStudents" label="Dodaj nowego kursanta" icon="pi pi-plus" (onClick)="addNewStudent()" data-clarity-unmask="true"></p-button>
    </div>
  </div>
  <div class="main-card p-2 md:p-3 fill-column">
    <p-tabView [(activeIndex)]="activeIndex" styleClass="tabview-lg">
      <p-tabPanel header="Wszyscy">
        <ng-container *ngIf="activeIndex === 0">
          <app-students-list-active class="fill-column" [resetTable]="resetTable.asObservable()"></app-students-list-active>
        </ng-container>
      </p-tabPanel>
      <p-tabPanel header="Zarchiwizowani">
        <ng-container *ngIf="activeIndex === 1">
          <app-students-list-archived class="fill-column"></app-students-list-archived>
        </ng-container>
      </p-tabPanel>
      <!-- Students with an account of their own join only by accepting the OSK's invitation. -->
      <p-tabPanel *ngIf="canAdministerStudents" header="Zaproszeni">
        <ng-container *ngIf="activeIndex === 2">
          <app-students-invitations [refresh]="resetTable.asObservable()"></app-students-invitations>
        </ng-container>
      </p-tabPanel>
    </p-tabView>
  </div>
</div> 